export const getTokenFromHashbang = () => {
    const hashbang = window.location.hash;
    return hashbang ? hashbang.replace("#!", "") : null;
};
export const removeHashbangFromUrl = () => {
    window.history.replaceState(null, null, " ");
    return true;
};
